import { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

/* ─────────────────────────────────────────────
   ICONS
───────────────────────────────────────────── */
const IconShield = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
  </svg>
);
const IconWifi = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M5 12.55a11 11 0 0 1 14.08 0" /><path d="M1.42 9a16 16 0 0 1 21.16 0" />
    <path d="M8.53 16.11a6 6 0 0 1 6.95 0" /><line x1="12" y1="20" x2="12.01" y2="20" strokeWidth="3" />
  </svg>
);
const IconPlus = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
    <line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);
const IconTrash = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="3 6 5 6 21 6" /><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
    <path d="M10 11v6M14 11v6" /><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
  </svg>
);
const IconEdit = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
  </svg>
);
const IconCheck = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12" />
  </svg>
);
const IconX = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
    <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);
const IconMapPin = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" /><circle cx="12" cy="10" r="3" />
  </svg>
);
const IconUsers = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);
const IconBriefcase = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="7" width="20" height="14" rx="2" />
    <path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2" /><path d="M2 12h20" />
  </svg>
);
const IconHome = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
    <polyline points="9 22 9 12 15 12 15 22" />
  </svg>
);
const IconPlane = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17.8 19.2L16 11l3.5-3.5A2.12 2.12 0 0 0 16.5 4.5L13 8 4.8 6.2a1 1 0 0 0-.9.3L3 7.5l7 4.7-1.5 1.5-3-.75L4 14l2.5 1.5L8 18l1.5-1.5L9 14l4.7 7 1-.9a1 1 0 0 0 .3-.9z" />
  </svg>
);
const IconPalmtree = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M13 8c0-2.76-2.46-5-5.5-5S2 5.24 2 8h11z" />
    <path d="M13 7.14A5.82 5.82 0 0 1 16.5 6c3.04 0 5.5 2.24 5.5 5h-9z" />
    <path d="M5.89 9.71c-2.15 2.15-2.3 5.47-.35 7.43l4.24-4.25.7-.7.71-.71 2.12-2.12c-1.95-1.96-5.27-1.8-7.42.35z" />
    <path d="M11 15.5c.5 2.5-.17 4.5-1 6.5h4c2-5.5-.5-12-1-14z" />
  </svg>
);
const IconChevronRight = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="9 18 15 12 9 6" />
  </svg>
);

/* ─────────────────────────────────────────────
   FINANCIAL YEAR
───────────────────────────────────────────── */
function getCurrentFY() {
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth() + 1;
  if (month >= 4) return { start: `${year}-04-01`, end: `${year + 1}-03-31` };
  return { start: `${year - 1}-04-01`, end: `${year}-03-31` };
}
const { start: FY_START, end: FY_END } = getCurrentFY();

/* ─────────────────────────────────────────────
   DATE / PERIOD HELPERS
───────────────────────────────────────────── */
function toDateStr(d) {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}
function isWeekend(dateStr) {
  return [0, 6].includes(new Date(dateStr + "T00:00:00").getDay());
}

function getPeriodRange(period) {
  const today    = new Date();
  const todayStr = toDateStr(today);
  const fyEnd    = todayStr < FY_END ? todayStr : FY_END;
  if (period === "today") return [todayStr, todayStr];
  if (period === "week") {
    const mon = new Date(today);
    mon.setDate(today.getDate() - ((today.getDay() + 6) % 7));
    return [toDateStr(mon) < FY_START ? FY_START : toDateStr(mon), fyEnd];
  }
  if (period === "month") {
    const start = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-01`;
    return [start < FY_START ? FY_START : start, fyEnd];
  }
  return [FY_START, fyEnd];
}

function buildDaysForPeriod(empRecord, period) {
  const { holidays = [], leaves = [], travels = [], logins = [] } = empRecord;
  const holidayMap = new Map(holidays.map((h) => [h.date, h.name]));
  const leaveMap   = new Map();
  for (const l of leaves) {
    let d = new Date(l.start + "T00:00:00"), end = new Date(l.end + "T00:00:00");
    while (d <= end) { leaveMap.set(toDateStr(d), l.type); d.setDate(d.getDate() + 1); }
  }
  const travelSet = new Set();
  for (const t of travels) {
    let d = new Date(t.start + "T00:00:00"), end = new Date(t.end + "T00:00:00");
    while (d <= end) { travelSet.add(toDateStr(d)); d.setDate(d.getDate() + 1); }
  }
  const loginMap = new Map();
  for (const l of logins) {
    if (!loginMap.has(l.date)) loginMap.set(l.date, []);
    loginMap.get(l.date).push({ time: l.time || l.loginTime, source: l.source });
  }
  const [startStr, endStr] = getPeriodRange(period);
  const result = [];
  let d = new Date(startStr + "T00:00:00"), end = new Date(endStr + "T00:00:00");
  while (d <= end) {
    const dateStr   = toDateStr(d);
    const weekend   = isWeekend(dateStr);
    const holName   = holidayMap.get(dateStr);
    const leaveType = leaveMap.get(dateStr);
    const isTravel  = travelSet.has(dateStr);
    const segments  = loginMap.get(dateStr) || [];
    let status = "workday";
    if (weekend) status = "weekend";
    else if (holName) status = "holiday";
    else if (leaveType) status = "leave";
    else if (isTravel)  status = "travel";
    result.push({ date: dateStr, status, segments });
    d.setDate(d.getDate() + 1);
  }
  return result;
}

function computeStats(days) {
  let office = 0, wfh = 0, travel = 0, leave = 0, noActivity = 0;
  for (const d of days) {
    if (d.status === "leave")   { leave++;  continue; }
    if (d.status === "travel")  { travel++; continue; }
    if (d.status === "weekend" || d.status === "holiday") continue;
    if (d.segments.length === 0) { noActivity++; continue; }
    if (d.segments.some((s) => s.source === "office")) office++;
    else wfh++;
  }
  return { office, wfh, travel, leave, noActivity };
}

/* ─────────────────────────────────────────────
   AVATAR
───────────────────────────────────────────── */
const AVATAR_COLORS = [
  ["#e8f5e9","#2e7d32"],["#e3f2fd","#1565c0"],["#fce4ec","#c62828"],
  ["#fff3e0","#e65100"],["#f3e5f5","#6a1b9a"],["#e0f7fa","#00695c"],
  ["#fff8e1","#f57f17"],["#fbe9e7","#bf360c"],
];
function getAvatarColors(name = "") {
  return AVATAR_COLORS[(name.charCodeAt(0) || 0) % AVATAR_COLORS.length];
}
function initials(name = "") {
  const p = name.trim().split(" ");
  return (p[0]?.[0] || "") + (p[1]?.[0] || "");
}

/* ─────────────────────────────────────────────
   STAT PILL
───────────────────────────────────────────── */
function StatPill({ value, label, tone }) {
  const C = {
    office:     { bg: "#e8faf2", text: "#16a34a", border: "#bbf7d0" },
    wfh:        { bg: "#eff6ff", text: "#2563eb", border: "#bfdbfe" },
    travel:     { bg: "#fff7ed", text: "#ea580c", border: "#fed7aa" },
    leave:      { bg: "#fdf2f8", text: "#db2777", border: "#fbcfe8" },
    noActivity: { bg: "#f3f4f6", text: "#6b7280", border: "#d1d5db" },
  };
  const c = C[tone] || C.office;
  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "6px 10px", borderRadius: 10, background: c.bg, border: `1px solid ${c.border}`, minWidth: 48 }}>
      <span style={{ fontSize: 17, fontWeight: 700, color: c.text, lineHeight: 1 }}>{value}</span>
      <span style={{ fontSize: 10, fontWeight: 600, color: c.text, opacity: 0.7, marginTop: 3, textTransform: "uppercase", letterSpacing: "0.04em" }}>{label}</span>
    </div>
  );
}

/* ─────────────────────────────────────────────
   EMPLOYEE CARD — clickable
───────────────────────────────────────────── */
function EmployeeCard({ emp, period, onCardClick }) {
  const days  = useMemo(() => buildDaysForPeriod(emp, period), [emp, period]);
  const stats = useMemo(() => computeStats(days), [days]);
  const [bg, fg] = getAvatarColors(emp.fullName);

  return (
    <div
      onClick={() => onCardClick(emp.employeeId, emp.fullName)}
      style={{
        background: "#fff", borderRadius: 16, padding: "18px 20px",
        border: "1px solid #e5e7eb", boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
        cursor: "pointer", transition: "box-shadow 0.15s, transform 0.15s",
        position: "relative",
      }}
      onMouseEnter={e => { e.currentTarget.style.boxShadow = "0 6px 20px rgba(0,0,0,0.12)"; e.currentTarget.style.transform = "translateY(-2px)"; }}
      onMouseLeave={e => { e.currentTarget.style.boxShadow = "0 1px 3px rgba(0,0,0,0.06)"; e.currentTarget.style.transform = "translateY(0)"; }}
    >
      <div style={{ position: "absolute", top: 18, right: 16, color: "#d1d5db" }}><IconChevronRight /></div>
      <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 14 }}>
        <div style={{ width: 42, height: 42, borderRadius: "50%", background: bg, color: fg, display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 700, fontSize: 14, flexShrink: 0 }}>
          {initials(emp.fullName).toUpperCase()}
        </div>
        <div style={{ flex: 1, minWidth: 0, paddingRight: 20 }}>
          <div style={{ fontWeight: 650, fontSize: 14, color: "#111827", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{emp.fullName}</div>
          <div style={{ fontSize: 12, color: "#6b7280", marginTop: 2, display: "flex", alignItems: "center", gap: 4 }}>
            <IconMapPin />{emp.worklocationName || "Unknown"}
          </div>
        </div>
      </div>
      <div style={{ display: "flex", gap: 7, flexWrap: "wrap" }}>
        <StatPill value={stats.office}     label="Office"   tone="office"     />
        <StatPill value={stats.wfh}        label="WFH"      tone="wfh"        />
        <StatPill value={stats.travel}     label="Travel"   tone="travel"     />
        <StatPill value={stats.leave}      label="Leave"    tone="leave"      />
        <StatPill value={stats.noActivity} label="No Login" tone="noActivity" />
      </div>
    </div>
  );
}

/* ─────────────────────────────────────────────
   AGGREGATE TILE
───────────────────────────────────────────── */
function AggregateTile({ Icon, value, label, tone }) {
  const T = {
    office:     { accent: "#16a34a", iconBg: "#dcfce7" },
    wfh:        { accent: "#2563eb", iconBg: "#dbeafe" },
    travel:     { accent: "#ea580c", iconBg: "#fed7aa" },
    leave:      { accent: "#db2777", iconBg: "#fce7f3" },
    noActivity: { accent: "#6b7280", iconBg: "#e5e7eb" },
  };
  const t = T[tone];
  return (
    <div style={{ background: "#fff", border: "1px solid #e5e7eb", borderRadius: 14, padding: "16px 18px", display: "flex", alignItems: "center", gap: 14, flex: "1 1 150px", boxShadow: "0 1px 2px rgba(0,0,0,0.04)" }}>
      <div style={{ width: 40, height: 40, borderRadius: 10, background: t.iconBg, color: t.accent, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}><Icon /></div>
      <div>
        <div style={{ fontSize: 26, fontWeight: 750, color: "#111827", lineHeight: 1, fontVariantNumeric: "tabular-nums" }}>{value}</div>
        <div style={{ fontSize: 11, color: "#6b7280", marginTop: 4 }}>{label}</div>
      </div>
    </div>
  );
}

/* ─────────────────────────────────────────────
   FILTER PILLS + PERIOD TAB
───────────────────────────────────────────── */
function LocationPill({ label, count, active, onClick }) {
  return (
    <button onClick={onClick} style={{ padding: "6px 13px", borderRadius: 999, border: `1.5px solid ${active ? "#111827" : "#e5e7eb"}`, background: active ? "#111827" : "#fff", color: active ? "#fff" : "#374151", fontSize: 12.5, fontWeight: 550, cursor: "pointer", display: "flex", alignItems: "center", gap: 6, transition: "all 0.15s", whiteSpace: "nowrap" }}>
      <IconMapPin />
      {label}
      <span style={{ background: active ? "rgba(255,255,255,0.2)" : "#f3f4f6", color: active ? "#fff" : "#6b7280", borderRadius: 999, padding: "1px 7px", fontSize: 11, fontWeight: 650 }}>{count}</span>
    </button>
  );
}
function StatusPill({ label, active, onClick }) {
  return (
    <button onClick={onClick} style={{ padding: "6px 14px", borderRadius: 999, border: `1.5px solid ${active ? "#111827" : "#e5e7eb"}`, background: active ? "#111827" : "#fff", color: active ? "#fff" : "#374151", fontSize: 12.5, fontWeight: 550, cursor: "pointer", transition: "all 0.15s" }}>{label}</button>
  );
}
function PeriodTab({ label, active, onClick }) {
  return (
    <button onClick={onClick} style={{ padding: "7px 16px", borderRadius: 8, border: "none", background: active ? "#fff" : "transparent", color: active ? "#111827" : "#6b7280", fontSize: 13.5, fontWeight: active ? 650 : 500, cursor: "pointer", boxShadow: active ? "0 1px 3px rgba(0,0,0,0.10)" : "none", transition: "all 0.15s" }}>{label}</button>
  );
}

/* ─────────────────────────────────────────────
   IP RANGE COMPONENTS
───────────────────────────────────────────── */
const inp = (focused) => ({ width: "100%", boxSizing: "border-box", padding: "9px 12px", borderRadius: 8, border: `1.5px solid ${focused ? "#0d9488" : "#e5e7eb"}`, fontSize: 13.5, color: "#111827", outline: "none", fontFamily: "inherit", background: "#fff", transition: "border-color 0.15s" });

function IpTag({ ip, onRemove }) {
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 5, background: "#f0fdfa", border: "1px solid #99f6e4", color: "#0d9488", borderRadius: 6, fontSize: 12, fontWeight: 600, fontFamily: "monospace", padding: "3px 8px" }}>
      {ip}
      <button onClick={() => onRemove(ip)} style={{ background: "none", border: "none", cursor: "pointer", color: "#0d9488", padding: 0, display: "flex", alignItems: "center", opacity: 0.7 }}
        onMouseEnter={e => e.currentTarget.style.opacity = 1}
        onMouseLeave={e => e.currentTarget.style.opacity = 0.7}
      ><IconX /></button>
    </span>
  );
}

function WorklocationRow({ loc, onUpdate, onClearAllIps }) {
  const [editing,   setEditing]   = useState(false);
  const [ips,       setIps]       = useState(() => loc.ipaddress ? loc.ipaddress.split(",").map(s => s.trim()).filter(Boolean) : []);
  const [newIp,     setNewIp]     = useState("");
  const [saving,    setSaving]    = useState(false);
  const [error,     setError]     = useState(null);
  const [ipFocused, setIpFocused] = useState(false);

  const handleAddIp = () => {
    const t = newIp.trim();
    if (!t) return;
    if (ips.includes(t)) { setError("IP already in list."); return; }
    setIps(p => [...p, t]); setNewIp(""); setError(null);
  };
 const handleSave = async () => {
  setSaving(true); setError(null);
  // Flush any IP sitting in the input box that wasn't explicitly "Added" yet
  const pending = newIp.trim();
  const finalIps = pending && !ips.includes(pending) ? [...ips, pending] : ips;
  const ok = await onUpdate(loc.id, finalIps);
  setSaving(false);
  if (ok) { setEditing(false); setNewIp(""); } else setError("Failed to save.");
};
  const handleCancel = () => {
    setIps(loc.ipaddress ? loc.ipaddress.split(",").map(s => s.trim()).filter(Boolean) : []);
    setNewIp(""); setError(null); setEditing(false);
  };
  const currentIps = loc.ipaddress ? loc.ipaddress.split(",").map(s => s.trim()).filter(Boolean) : [];

  if (editing) return (
    <div style={{ padding: "16px 18px", background: "#f8faff", border: "1.5px solid #bfdbfe", borderRadius: 12 }}>
      <div style={{ fontSize: 14, fontWeight: 700, color: "#111827", marginBottom: 12 }}>
        {loc.name} <span style={{ marginLeft: 6, fontSize: 11, color: "#9ca3af", fontWeight: 400 }}>Editing IPs</span>
      </div>
      <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginBottom: 12 }}>
        {ips.length === 0 && <span style={{ fontSize: 12, color: "#9ca3af", fontStyle: "italic" }}>No IPs — add one below</span>}
        {ips.map(ip => <IpTag key={ip} ip={ip} onRemove={ip => setIps(p => p.filter(i => i !== ip))} />)}
      </div>
      <div style={{ display: "flex", gap: 8, marginBottom: error ? 8 : 12, flexWrap: "wrap" }}>
        <input value={newIp} onChange={e => setNewIp(e.target.value)}
          onKeyDown={e => { if (e.key === "Enter") { e.preventDefault(); handleAddIp(); } }}
          placeholder="Add IP e.g. 101.93.52.106"
          style={{ ...inp(ipFocused), maxWidth: 280, flex: "1 1 200px" }}
          onFocus={() => setIpFocused(true)} onBlur={() => setIpFocused(false)}
        />
        <button onClick={handleAddIp} style={{ display: "flex", alignItems: "center", gap: 5, padding: "8px 14px", borderRadius: 8, border: "none", background: "#0d9488", color: "#fff", fontSize: 13, fontWeight: 700, cursor: "pointer", whiteSpace: "nowrap" }}>
          <IconPlus /> Add IP
        </button>
      </div>
      {error && <p style={{ margin: "0 0 8px", fontSize: 12, color: "#dc2626" }}>{error}</p>}
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
        <button onClick={handleSave} disabled={saving} style={{ display: "flex", alignItems: "center", gap: 5, padding: "7px 16px", borderRadius: 8, border: "none", background: saving ? "#99f6e4" : "#0d9488", color: "#fff", fontSize: 13, fontWeight: 700, cursor: saving ? "not-allowed" : "pointer" }}>
          <IconCheck /> {saving ? "Saving…" : "Save"}
        </button>
        <button onClick={handleCancel} style={{ display: "flex", alignItems: "center", gap: 5, padding: "7px 14px", borderRadius: 8, border: "1px solid #e5e7eb", background: "#fff", fontSize: 13, fontWeight: 600, color: "#374151", cursor: "pointer" }}>
          <IconX /> Cancel
        </button>
      </div>
    </div>
  );

  return (
    <div style={{ padding: "13px 18px", background: "#fff", border: "1px solid #e5e7eb", borderRadius: 12, display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 12, transition: "box-shadow 0.15s" }}
      onMouseEnter={e => e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.07)"}
      onMouseLeave={e => e.currentTarget.style.boxShadow = "none"}
    >
      <div style={{ minWidth: 0, flex: 1 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 7, flexWrap: "wrap" }}>
          <div style={{ width: 8, height: 8, borderRadius: "50%", background: currentIps.length ? "#16a34a" : "#9ca3af", flexShrink: 0 }} />
          <span style={{ fontSize: 14, fontWeight: 700, color: "#111827" }}>{loc.name}</span>
          {loc.timezone && <span style={{ fontSize: 11, color: "#9ca3af", background: "#f3f4f6", borderRadius: 4, padding: "1px 6px" }}>{loc.timezone}</span>}
        </div>
        {currentIps.length > 0
          ? <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
              {currentIps.map(ip => (
                <span key={ip} style={{ fontSize: 12, fontFamily: "monospace", fontWeight: 600, background: "#f0fdfa", border: "1px solid #99f6e4", color: "#0d9488", borderRadius: 6, padding: "2px 8px" }}>{ip}</span>
              ))}
            </div>
          : <span style={{ fontSize: 12, color: "#f59e0b", fontStyle: "italic" }}>⚠ No IP addresses — all logins will be WFH</span>
        }
      </div>
      <div style={{ display: "flex", gap: 6, flexShrink: 0 }}>
        {[
          { fn: () => setEditing(true), title: "Edit", hBg: "#eff6ff", hC: "#2563eb", hB: "#bfdbfe", icon: <IconEdit /> },
          { fn: () => onClearAllIps(loc), title: "Clear IPs", hBg: "#fff1f2", hC: "#dc2626", hB: "#fca5a5", icon: <IconTrash /> },
        ].map((btn, i) => (
          <button key={i} onClick={btn.fn} title={btn.title} style={{ width: 32, height: 32, borderRadius: 8, border: "1px solid #e5e7eb", background: "#f9fafb", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", color: "#6b7280", transition: "all 0.15s" }}
            onMouseEnter={e => { e.currentTarget.style.background = btn.hBg; e.currentTarget.style.color = btn.hC; e.currentTarget.style.borderColor = btn.hB; }}
            onMouseLeave={e => { e.currentTarget.style.background = "#f9fafb"; e.currentTarget.style.color = "#6b7280"; e.currentTarget.style.borderColor = "#e5e7eb"; }}
          >{btn.icon}</button>
        ))}
      </div>
    </div>
  );
}

function ConfirmModal({ name, onConfirm, onCancel }) {
  return (
    <div onClick={e => { if (e.target === e.currentTarget) onCancel(); }} style={{ position: "fixed", inset: 0, zIndex: 1000, background: "rgba(0,0,0,0.4)", display: "flex", alignItems: "center", justifyContent: "center", padding: 20, fontFamily: "'DM Sans','Segoe UI',sans-serif" }}>
      <div style={{ background: "#fff", borderRadius: 14, padding: "28px 28px 22px", maxWidth: 380, width: "100%", boxShadow: "0 20px 60px rgba(0,0,0,0.16)" }}>
        <h3 style={{ margin: "0 0 8px", fontSize: 17, fontWeight: 700, color: "#111827" }}>Clear all IPs?</h3>
        <p style={{ margin: "0 0 20px", fontSize: 14, color: "#6b7280", lineHeight: 1.5 }}>
          All IP addresses for <strong style={{ color: "#111827" }}>{name}</strong> will be removed. Logins will be classified as WFH going forward.
        </p>
        <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
          <button onClick={onCancel} style={{ padding: "8px 18px", borderRadius: 8, border: "1px solid #e5e7eb", background: "#fff", fontSize: 14, fontWeight: 600, color: "#374151", cursor: "pointer" }}>Cancel</button>
          <button onClick={onConfirm} style={{ padding: "8px 18px", borderRadius: 8, border: "none", background: "#dc2626", color: "#fff", fontSize: 14, fontWeight: 700, cursor: "pointer" }}>Clear IPs</button>
        </div>
      </div>
    </div>
  );
}

/* ─────────────────────────────────────────────
   MAIN COMPONENT
───────────────────────────────────────────── */
const AdminConsole = () => {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const token        = localStorage.getItem("token");
  const navigate     = useNavigate();

  const [locations,     setLocations]     = useState([]);
  const [ipLoading,     setIpLoading]     = useState(false);
  const [ipError,       setIpError]       = useState(null);
  const [deleteTarget,  setDeleteTarget]  = useState(null);

  const [hrData,        setHrData]        = useState([]);
  const [hrLoading,     setHrLoading]     = useState(false);
  const [hrError,       setHrError]       = useState(null);
  const [period,        setPeriod]        = useState("today");
  const [selectedLocId, setSelectedLocId] = useState("all");
  const [selectedStatus,setSelectedStatus]= useState("all");

  const fetchLocations = async () => {
    try {
      setIpLoading(true); setIpError(null);
      const res = await axios.get(`${API_BASE_URL}/employeeinfos/admin/getIpAddress`, { headers: { Authorization: `Bearer ${token}` } });
      const rawLoc = res.data?.data; setLocations(Array.isArray(rawLoc) ? rawLoc : []);
    } catch { setIpError("Failed to load locations."); }
    finally { setIpLoading(false); }
  };

  const fetchHrData = async () => {
    try {
      setHrLoading(true); setHrError(null);
      // Dedicated admin endpoint — always returns ALL employees regardless of caller's ID
      const res = await axios.get(`${API_BASE_URL}/employeeinfos/admin/attendance-history`, { headers: { Authorization: `Bearer ${token}` } });
      const raw = res.data?.data;
      console.log("Admin Data",raw);
      
      setHrData(Array.isArray(raw) ? raw : []);
    } catch (err) {
      console.error("[AdminConsole] fetchHrData error:", err);
      setHrError("Failed to load attendance data.");
    }
    finally { setHrLoading(false); }
  };

  useEffect(() => { fetchLocations(); fetchHrData(); }, []); // eslint-disable-line

  const handleUpdate = async (id, ips) => {
    try {
      const res = await axios.put(`${API_BASE_URL}/employeeinfos/admin/worklocations/${id}/ipaddress`, { ipaddress: ips.join(",") }, { headers: { Authorization: `Bearer ${token}` } });
      if (res.data?.success) { setLocations(prev => prev.map(l => l.id === id ? { ...l, ipaddress: ips.join(",") } : l)); return true; }
      return false;
    } catch { return false; }
  };

  const handleClearConfirm = async () => {
    if (!deleteTarget) return;
    await handleUpdate(deleteTarget.id, []);
    setDeleteTarget(null);
  };

  // Navigate to user's attendance detail, passing userId via router state
  const handleCardClick = (employeeId, fullName) => {
    navigate("/personalinfo/attendanceView", {
      state: { viewUserId: employeeId, viewUserName: fullName },
    });
  };

  /* ── Derived ── */
  const safeHrData = Array.isArray(hrData) ? hrData : [];

  const worklocations = useMemo(() => {
    const map = new Map();
    for (const emp of safeHrData) {
      const id   = String(emp.worklocationId ?? emp.worklocation_id ?? "unknown");
      const name = emp.worklocationName || "Unknown";
      if (!map.has(id)) map.set(id, { id, name, count: 0 });
      map.get(id).count++;
    }
    return Array.from(map.values()).sort((a, b) => a.name.localeCompare(b.name));
  }, [safeHrData]);

  const locationFilteredEmps = useMemo(() => {
    if (selectedLocId === "all") return safeHrData;
    return safeHrData.filter(e => String(e.worklocationId ?? e.worklocation_id ?? "unknown") === selectedLocId);
  }, [safeHrData, selectedLocId]);

  const visibleEmployees = useMemo(() => {
    if (selectedStatus === "all") return locationFilteredEmps;
    return locationFilteredEmps.filter(emp => {
      const stats = computeStats(buildDaysForPeriod(emp, period));
      if (selectedStatus === "office")     return stats.office > 0;
      if (selectedStatus === "wfh")        return stats.wfh > 0;
      if (selectedStatus === "travel")     return stats.travel > 0;
      if (selectedStatus === "leave")      return stats.leave > 0;
      if (selectedStatus === "noActivity") return stats.noActivity > 0;
      return true;
    });
  }, [locationFilteredEmps, selectedStatus, period]);

  const aggregateStats = useMemo(() => {
    let office = 0, wfh = 0, travel = 0, leave = 0, noActivity = 0;
    for (const emp of locationFilteredEmps) {
      const s = computeStats(buildDaysForPeriod(emp, period));
      office += s.office; wfh += s.wfh; travel += s.travel; leave += s.leave; noActivity += s.noActivity;
    }
    return { office, wfh, travel, leave, noActivity };
  }, [locationFilteredEmps, period]);

  const periodLabel = { today: "today", week: "this week", month: "this month", year: "this FY" }[period] ?? period;

  return (
    <div style={{ minHeight: "100vh", background: "#f9fafb", fontFamily: "'DM Sans','Segoe UI',sans-serif" }}>

      {/* ── Sticky header ── */}
      <header style={{ background: "#fff", borderBottom: "1px solid #e5e7eb", padding: "0 28px", height: 56, display: "flex", alignItems: "center", justifyContent: "space-between", position: "sticky", top: 0, zIndex: 100 }}>
        <span style={{ fontWeight: 750, fontSize: 17, color: "#111827", letterSpacing: "-0.02em" }}>Work<span style={{ color: "#16a34a" }}>Track</span></span>
        <span style={{ background: "#f0fdf4", color: "#16a34a", border: "1px solid #bbf7d0", borderRadius: 999, padding: "3px 12px", fontSize: 12, fontWeight: 650 }}>Admin</span>
      </header>

      {/* ── Full-width main — same as UserAttendanceView ── */}
      <main style={{ padding: "32px 28px 60px" }}>

        {/* Page title */}
        <div style={{ display: "flex", alignItems: "flex-start", gap: 16, marginBottom: 28 }}>
          <div style={{ width: 48, height: 48, borderRadius: 13, flexShrink: 0, background: "#f0fdfa", color: "#0d9488", display: "flex", alignItems: "center", justifyContent: "center", border: "1px solid #99f6e4" }}>
            <IconShield />
          </div>
          <div>
            <h1 style={{ margin: 0, fontSize: 24, fontWeight: 750, color: "#111827", letterSpacing: "-0.02em" }}>Admin console</h1>
            <p style={{ margin: "3px 0 0", fontSize: 13.5, color: "#6b7280" }}>Manage office IP addresses and view attendance across all employees.</p>
          </div>
        </div>

        {/* ══ IP RANGES CARD ══ */}
        <div style={{ background: "#fff", border: "1px solid #e5e7eb", borderRadius: 16, padding: "20px 22px 18px", boxShadow: "0 1px 3px rgba(0,0,0,0.05)", marginBottom: 44 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 18 }}>
            <div style={{ width: 36, height: 36, borderRadius: 9, background: "#f0fdfa", color: "#0d9488", display: "flex", alignItems: "center", justifyContent: "center", border: "1px solid #ccfbf1" }}><IconWifi /></div>
            <div>
              <h2 style={{ margin: 0, fontSize: 15, fontWeight: 700, color: "#111827" }}>Office IP ranges</h2>
              <p style={{ margin: 0, fontSize: 12.5, color: "#6b7280" }}>Click <strong>Edit</strong> on any location to add or remove IPs.</p>
            </div>
          </div>

          {ipLoading && (
            <div style={{ textAlign: "center", padding: 40, color: "#6b7280" }}>
              <div style={{ width: 28, height: 28, border: "3px solid #e5e7eb", borderTopColor: "#0d9488", borderRadius: "50%", animation: "spin 0.7s linear infinite", margin: "0 auto 10px" }} />
              Loading…
              <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
            </div>
          )}
          {!ipLoading && ipError && (
            <div style={{ textAlign: "center", padding: 28 }}>
              <p style={{ color: "#ef4444", marginBottom: 10 }}>{ipError}</p>
              <button onClick={fetchLocations} style={{ padding: "7px 16px", borderRadius: 8, border: "none", background: "#111827", color: "#fff", fontWeight: 600, cursor: "pointer" }}>Retry</button>
            </div>
          )}
          {!ipLoading && !ipError && (
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              {locations.length === 0 && (
                <div style={{ padding: 24, textAlign: "center", border: "1.5px dashed #e5e7eb", borderRadius: 12, fontSize: 13, color: "#9ca3af" }}>No work locations found.</div>
              )}
              {locations.map(loc => (
                <WorklocationRow key={loc.id} loc={loc} onUpdate={handleUpdate} onClearAllIps={l => setDeleteTarget(l)} />
              ))}
            </div>
          )}
        </div>

        {/* ══ EMPLOYEE ATTENDANCE GRID ══ */}
        <div style={{ marginBottom: 20 }}>
          <h2 style={{ margin: "0 0 4px", fontSize: 20, fontWeight: 750, color: "#111827", letterSpacing: "-0.01em" }}>Employee attendance</h2>
          <p style={{ margin: 0, fontSize: 13, color: "#6b7280" }}>Click any card to view that employee's full attendance detail.</p>
        </div>

        {/* Location pills */}
        <div style={{ marginBottom: 14 }}>
          <div style={{ fontSize: 10, fontWeight: 700, color: "#9ca3af", letterSpacing: "0.1em", textTransform: "uppercase", marginBottom: 8 }}>Work Location</div>
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
            <LocationPill label="All locations" count={safeHrData.length} active={selectedLocId === "all"} onClick={() => setSelectedLocId("all")} />
            {worklocations.map(loc => (
              <LocationPill key={loc.id} label={loc.name} count={loc.count} active={selectedLocId === loc.id} onClick={() => setSelectedLocId(loc.id)} />
            ))}
          </div>
        </div>

        {/* Status pills */}
        <div style={{ marginBottom: 14 }}>
          <div style={{ fontSize: 10, fontWeight: 700, color: "#9ca3af", letterSpacing: "0.1em", textTransform: "uppercase", marginBottom: 8 }}>Attendance Type</div>
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
            {[["all","All"],["office","Office"],["wfh","WFH"],["travel","Travel"],["leave","Leave"],["noActivity","No Login"]].map(([v, l]) => (
              <StatusPill key={v} label={l} active={selectedStatus === v} onClick={() => setSelectedStatus(v)} />
            ))}
          </div>
        </div>

        {/* Period tabs */}
        <div style={{ display: "inline-flex", gap: 2, background: "#f3f4f6", borderRadius: 10, padding: "3px", marginBottom: 20 }}>
          {[["today","Today"],["week","Week"],["month","Month"],["year","Year"]].map(([v, l]) => (
            <PeriodTab key={v} label={l} active={period === v} onClick={() => setPeriod(v)} />
          ))}
        </div>

        {/* Aggregate tiles */}
        {!hrLoading && !hrError && (
          <div style={{ display: "flex", gap: 12, flexWrap: "wrap", marginBottom: 24 }}>
            <AggregateTile Icon={IconBriefcase} value={aggregateStats.office}     label={`office days ${periodLabel}`}    tone="office"     />
            <AggregateTile Icon={IconHome}      value={aggregateStats.wfh}        label={`WFH days ${periodLabel}`}       tone="wfh"        />
            <AggregateTile Icon={IconPlane}     value={aggregateStats.travel}     label={`travel days ${periodLabel}`}    tone="travel"     />
            <AggregateTile Icon={IconPalmtree}  value={aggregateStats.leave}      label={`leave days ${periodLabel}`}     tone="leave"      />
            <AggregateTile Icon={IconUsers}     value={aggregateStats.noActivity} label={`no login ${periodLabel}`}       tone="noActivity" />
          </div>
        )}

        {hrLoading && (
          <div style={{ textAlign: "center", padding: 60, color: "#6b7280" }}>
            <div style={{ width: 32, height: 32, border: "3px solid #e5e7eb", borderTopColor: "#16a34a", borderRadius: "50%", animation: "spin 0.7s linear infinite", margin: "0 auto 12px" }} />
            Loading attendance data…
          </div>
        )}
        {!hrLoading && hrError && (
          <div style={{ textAlign: "center", padding: 40 }}>
            <p style={{ color: "#ef4444", marginBottom: 12 }}>{hrError}</p>
            <button onClick={fetchHrData} style={{ padding: "8px 20px", borderRadius: 8, border: "none", background: "#111827", color: "#fff", fontWeight: 600, cursor: "pointer" }}>Retry</button>
          </div>
        )}

        {!hrLoading && !hrError && (
          <>
            <div style={{ fontSize: 11, fontWeight: 700, color: "#9ca3af", letterSpacing: "0.1em", textTransform: "uppercase", marginBottom: 14, display: "flex", alignItems: "center", gap: 6 }}>
              <IconUsers /> People ({visibleEmployees.length} of {safeHrData.length})
            </div>
            {visibleEmployees.length === 0
              ? <div style={{ textAlign: "center", padding: 60, color: "#9ca3af" }}>No employees match this filter.</div>
              : (
                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))", gap: 14 }}>
                  {visibleEmployees.map(emp => (
                    <EmployeeCard key={emp.employeeId} emp={emp} period={period} onCardClick={handleCardClick} />
                  ))}
                </div>
              )
            }
          </>
        )}

        <footer style={{ marginTop: 48, textAlign: "center", fontSize: 12, color: "#d1d5db" }}>
          WorkTrack · Admin Console · FY {FY_START} → {FY_END}
        </footer>
      </main>

      {deleteTarget && <ConfirmModal name={deleteTarget.name} onConfirm={handleClearConfirm} onCancel={() => setDeleteTarget(null)} />}
    </div>
  );
};

export default AdminConsole;